import { Modal } from "antd"
import FormGenerator from "../../form/FormGenerator"

const CrmFormGeneratorModal = ({ crmId, clientId, accountId, isModalOpen, onClose }) => {
    return (
        <Modal open={isModalOpen} onCancel={() => onClose()} footer={[]}>
            <div className='top-header'>
                <header>Form Bundle</header>
            </div>
            <FormGenerator
                crmId={crmId}
                clientId={clientId} 
                accountId={accountId}
            />
        </Modal>
    )
}

export default CrmFormGeneratorModal


